import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, ArrowRight } from 'lucide-react';
export function HomeKarateVsTaekwondo() {
  return <section className="py-24 bg-ink relative overflow-hidden" data-id="element-1733">
      <div className="absolute top-0 right-0 w-1/3 h-full bg-storm-red transform skew-x-12 translate-x-32 opacity-10 pointer-events-none" data-id="element-1734" />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1735">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-1736">
          <span className="inline-block bg-storm-red text-white px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide mb-6" data-id="element-1737">
            Karate or Taekwondo?
          </span>
          <h2 className="text-4xl md:text-5xl text-white mb-6 leading-tight" data-id="element-1738">
            Searching for Kids Karate or Martial Arts Near You?
          </h2>
          <p className="text-lg text-gray-warm leading-relaxed" data-id="element-1739">
            Many parents search for kids karate when they're really looking for
            a structured martial arts program that builds confidence, focus,
            discipline, and physical skills. Storm teaches taekwondo, a powerful
            martial art that gives kids real goals, strong coaching, and a
            positive place to grow.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 mb-12" data-id="element-1740">
          {['Beginner-friendly classes for ages 3+', 'Programs for kids, adults, and families', 'Located in Farmington Hills and serving nearby communities'].map((point, idx) => <div key={idx} className="flex items-start gap-3 bg-charcoal p-5 rounded-2xl border border-white/10" data-id="element-1741">
              <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0 mt-0.5" data-id="element-1742" />
              <p className="text-white font-bold leading-snug" data-id="element-1743">{point}</p>
            </div>)}
        </div>

        <div className="flex justify-center" data-id="element-1744">
          <Link to="/Programs.html" className="btn-primary inline-flex items-center gap-2" data-id="element-1745">
            See Storm Programs
            <ArrowRight className="w-5 h-5" data-id="element-1746" />
          </Link>
        </div>
      </div>
    </section>;
}